$(document).ready(function () {
  function updateBadgeClass() {
    $(".field-check.test.multi.active, .field-check.test.bundle.active").each(function () {
      $(this).closest("li").find(".pack-info").addClass("badge");
    });

    $(".field-check.test.single.active").each(function () {
      $(this).closest("li").find(".pack-info").removeClass("badge");
    });
  }

  updateBadgeClass();

  // Monitor URL changes
  let lastUrl = location.href;
  setInterval(() => {
    const currentUrl = location.href;
    if (lastUrl !== currentUrl) {
      lastUrl = currentUrl;
      updateBadgeClass();
    }
  }, 500);

  // Dynamic click handler
  $(document).on("click", ".customProductGrid .field-check.test", function () {
    const $this = $(this);
    const $form = $this.closest("form");
    const $li = $this.closest("li");

    $form.find(".field-check").removeClass("active");
    $this.addClass("active");

    // Reset price visibility
    $form.find(".single-price, .pack-price, .bundle-price").removeClass("active");
    $li.find(".badge-2, .badge-3, .discount-1, .discount-2, .discount-3").removeClass("active-badge");

    if ($this.hasClass("single")) {
      $form.find(".single-price").addClass("active");
      $li.find(".discount-1").addClass("active-badge");
    } else if ($this.hasClass("multi")) {
      $form.find(".pack-price").addClass("active");
      $li.find(".badge-2, .discount-2").addClass("active-badge");
    } else if ($this.hasClass("bundle")) {
      $form.find(".bundle-price").addClass("active");
      $li.find(".badge-3, .discount-3").addClass("active-badge");
    }

    // Update hidden variant ID
    const variantId = $this.find(".unitPallet").data("variant-id");
    $form.find("input.variantId").val(variantId);
  });
});

// Reload on specific pack_discount interaction
$(document).on("click", ".pack_discount .listening", function () {
  setTimeout(() => location.reload(), 1000);
});
